import { Container } from './Container';
import { socialLinks, cvUrl, contactInfo } from '../../data';

function SocialIcon({ type }) {
  const icons = {
    github: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
      </svg>
    ),
    linkedin: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
    email: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
    telegram: (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
      </svg>
    ),
  };

  return icons[type] || null;
}

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-bg-secondary/50 px-4 sm:px-6">
      <Container>
        <div className="footer-content py-10 sm:py-12">
          {/* Top section */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10 mb-8 sm:mb-10">
            {/* Brand */}
            <div>
              <h3 className="text-text-primary font-display font-bold text-xl sm:text-2xl mb-2 sm:mb-3">
                Adam<span className="text-accent-primary">.</span>dev
              </h3>
              <p className="text-text-muted text-sm sm:text-base max-w-xs leading-relaxed">
                Software engineer focused on e-commerce platforms, backend systems, and enterprise integrations.
              </p>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-text-muted font-mono text-xs sm:text-sm uppercase tracking-wider mb-3 sm:mb-4">
                Contact
              </h4>
              <ul className="space-y-2">
                <li>
                  <a
                    href={`mailto:${contactInfo.email}`}
                    className="text-text-secondary hover:text-accent-primary transition-colors text-sm sm:text-base break-all"
                  >
                    {contactInfo.email}
                  </a>
                </li>
                <li>
                  <a
                    href={`https://${contactInfo.telegram}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-text-secondary hover:text-accent-primary transition-colors text-sm sm:text-base"
                  >
                    {contactInfo.telegram}
                  </a>
                </li>
              </ul>
            </div>

            {/* Links */}
            <div>
              <h4 className="text-text-muted font-mono text-xs sm:text-sm uppercase tracking-wider mb-3 sm:mb-4">
                Links
              </h4>
              <ul className="space-y-2">
                <li>
                  <a
                    href="#experience"
                    className="text-text-secondary hover:text-accent-primary transition-colors text-sm sm:text-base"
                  >
                    Experience
                  </a>
                </li>
                <li>
                  <a
                    href="#skills"
                    className="text-text-secondary hover:text-accent-primary transition-colors text-sm sm:text-base"
                  >
                    Skills
                  </a>
                </li>
                <li>
                  <a
                    href={cvUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-text-secondary hover:text-accent-primary transition-colors text-sm sm:text-base"
                  >
                    Resume / CV
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Divider */}
          <div className="h-px bg-gradient-to-r from-transparent via-border to-transparent mb-6 sm:mb-8" />

          {/* Bottom section */}
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-text-muted font-mono text-xs sm:text-sm order-2 sm:order-1">
              &copy; {currentYear} Adam Fernandez
            </p>

            {/* Social icons */}
            <div className="flex items-center gap-3 sm:gap-4 order-1 sm:order-2">
              {socialLinks.map((link) => (
                <a
                  key={link.id}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 rounded-lg text-text-muted hover:text-accent-primary hover:bg-accent-dim transition-all"
                  aria-label={link.label}
                >
                  <SocialIcon type={link.icon} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
}
